import { render, staticRenderFns } from "./404.vue?vue&type=template&id=056066c6&scoped=true"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=056066c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056066c6",
  null
  
)

export default component.exports